import { __assign, __read, __spreadArray, __values } from "tslib";
import { ActionButton } from '@fluentui/react';
import { CustomFilterType, CustomPivotTabIdSeparator, FileFilterKey, getCustomPivotFromTabId, getCustomPivotTabId, LocationFilterKey, PendingCustomPivotId, SortOption, SortOrder, useAllFilters, useFilterNameMap, useSortedDocuments, } from '@office-start/base-edgeworth-control';
import EmptyStateControl, { useEmptyState, } from '@office-start/empty-state-control';
import { IconNames } from '@office-start/fabric-icon-subset-utility';
import { useMemoizedState, usePrevious } from '@office-start/hooks-utility';
import { LayoutContent, LayoutOption, LayoutOptions, LayoutSwitchControl, } from '@office-start/layout-switch-control';
import PivotsControl, { PivotsOverflow, } from '@office-start/pivots-control';
import { format } from '@office-start/string-formatter-utility';
import classNames from 'classnames';
import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { CustomPivotsMenuControl } from './CustomPivotsMenuControl/CustomPivotsMenuControl';
import styles from './QuickAccessControl.module.scss';
import { getCustomPivotIconElement } from './utilities/getCustomPivotIconElement';
import { QuickAccessGridViewControl } from './views/QuickAccessGridView';
import { QuickAccessListViewControl } from './views/QuickAccessListView';
export var QuickAccessControl = function (_a) {
    var PeopleCard = _a.PeopleCard, allDocs = _a.allDocs, callbacks = _a.callbacks, dateResources = _a.dateResources, edgeworthItemResources = _a.edgeworthItemResources, edgeworthTaggingResources = _a.edgeworthTaggingResources, emptyStateResources = _a.emptyStateResources, identity = _a.identity, isError = _a.isError, isVisualRefresh = _a.isVisualRefresh, _b = _a.gridViewEnabled, gridViewEnabled = _b === void 0 ? false : _b, layoutResources = _a.layoutResources, linksEnabled = _a.linksEnabled, locResources = _a.locResources, preferredCulture = _a.preferredCulture, uploadButton = _a.uploadButton, maxItemCount = _a.maxItemCount, navigateToMyContent = _a.navigateToMyContent, customPivotsEnabled = _a.customPivotsEnabled, getOrCreateUpnNameMap = _a.getOrCreateUpnNameMap, fetchPictureData = _a.fetchPictureData, customPivotsProps = _a.customPivotsProps, deleteCustomPivot = _a.deleteCustomPivot, fluidSupportEnabled = _a.fluidSupportEnabled, currentLayout = _a.currentLayout, darkMode = _a.darkMode, workloadColorMap = _a.workloadColorMap, cdnDomain = _a.cdnDomain, tags = _a.tags, msaUserHint = _a.msaUserHint, onPivotRefChange = _a.onPivotRefChange, isDesktopApp = _a.isDesktopApp, commandingEnabled = _a.commandingEnabled, commandFilterProps = _a.commandFilterProps;
    var _c = __read(useState(false), 2), showCustomPivotMenu = _c[0], setShowCustomPivotMenu = _c[1];
    var _d = __read(useMemoizedState(customPivotsProps), 2), customPivots = _d[0], setCustomPivots = _d[1];
    var onSelectTab = callbacks.onSelectTab, onAddCustomPivot = callbacks.onAddCustomPivot, onRemoveCustomPivot = callbacks.onRemoveCustomPivot, onChangeLayout = callbacks.onChangeLayout, onShowCustomPivotsMenu = callbacks.onShowCustomPivotsMenu;
    var _e = __read(useState(''), 2), activeCustomPivotTabId = _e[0], setActiveCustomPivotTabId = _e[1];
    var filterNameMap = useFilterNameMap(locResources);
    var wrappedOnSelectTab = useCallback(function (tabEvent) {
        setActiveCustomPivotTabId('');
        if (tabEvent && tabEvent.tabId === PendingCustomPivotId) {
            setShowCustomPivotMenu(true);
        }
        else {
            setShowCustomPivotMenu(false);
        }
        if (onSelectTab) {
            onSelectTab(tabEvent);
        }
    }, [onSelectTab]);
    var getCustomPivotTitle = useCallback(function (customPivot) {
        switch (customPivot.customFilterType) {
            case CustomFilterType.FileType:
                var fileFilterKey = Object.values(FileFilterKey).find(function (key) { return key === customPivot.customFilterKey; });
                return !!fileFilterKey
                    ? filterNameMap.get(fileFilterKey)
                    : '';
            case CustomFilterType.Location:
                var locationFilterKey = Object.values(LocationFilterKey).find(function (key) { return key === customPivot.customFilterKey; });
                return !!locationFilterKey
                    ? filterNameMap.get(locationFilterKey)
                    : '';
            case CustomFilterType.SharedBy:
                var sharedByName = '';
                if (getOrCreateUpnNameMap) {
                    var upnNameMap = getOrCreateUpnNameMap();
                    if (upnNameMap.has(customPivot.customFilterKey)) {
                        sharedByName =
                            upnNameMap.get(customPivot.customFilterKey) ||
                                '';
                    }
                }
                if (!sharedByName) {
                    //for when input is not an email
                    sharedByName = customPivot.customFilterKey;
                }
                return format(locResources.sharedByPivotLabel, sharedByName);
            case CustomFilterType.OwnedBy:
                var ownedByName = '';
                if (getOrCreateUpnNameMap) {
                    var upnNameMap = getOrCreateUpnNameMap();
                    if (upnNameMap.has(customPivot.customFilterKey)) {
                        ownedByName =
                            upnNameMap.get(customPivot.customFilterKey) ||
                                '';
                    }
                }
                return format(locResources.ownedByPivotLabel, ownedByName);
            case CustomFilterType.Tag:
                return format(edgeworthTaggingResources.tagCustomPivotText, customPivot.customFilterKey);
            case CustomFilterType.Tagv2:
                if (!customPivot.customFilterTitle) {
                    return '';
                }
                return format(edgeworthTaggingResources.tagCustomPivotText, customPivot.customFilterTitle);
            case CustomFilterType.Pending:
                return locResources.newPivotLabel;
            default:
                return '';
        }
    }, [
        filterNameMap,
        getOrCreateUpnNameMap,
        locResources,
        edgeworthTaggingResources,
    ]);
    var _f = useAllFilters({
        linksEnabled: linksEnabled,
        locResources: locResources,
        identity: identity,
        onSelectTab: wrappedOnSelectTab,
        customPivots: customPivots,
        getCustomPivotTitle: getCustomPivotTitle,
        getCustomPivotIconElement: getCustomPivotIconElement,
        PendingCustomPivotId: PendingCustomPivotId,
        activeCustomPivotTabId: activeCustomPivotTabId,
        fetchPictureData: fetchPictureData,
        tagMap: tags === null || tags === void 0 ? void 0 : tags.tagIdToItemsDocumentIdsMap,
        getTagIdByTagValue: tags === null || tags === void 0 ? void 0 : tags.getTagIdByTagValue,
        msaUserHint: msaUserHint,
        onPivotRefChange: onPivotRefChange,
    }), filterFunctions = _f.filterFunctions, tabsFilter = _f.tabsFilter, allFilterModels = _f.allFilterModels, showHidden = _f.showHidden;
    var wrappedCallbacks = useMemo(function () {
        var result = __assign({}, callbacks);
        result.onDocumentClick = function (item, index, event) {
            callbacks.onDocumentClick &&
                callbacks.onDocumentClick(item, index, event, allFilterModels, currentLayout === LayoutOption.Grid);
        };
        return result;
    }, [allFilterModels, callbacks, currentLayout]);
    var myContentButtonStyle = useMemo(function () { return ({
        textContainer: styles['my-content-button__text'],
        flexContainer: styles[isVisualRefresh
            ? 'my-content-button__container-refresh'
            : 'my-content-button__container'],
    }); }, [isVisualRefresh]);
    var rightArrowIconProps = useMemo(function () { return ({
        iconName: IconNames.Forward,
        styles: {
            root: styles['my-content-button__icon'],
        },
    }); }, []);
    var sortedDocs = useSortedDocuments(allDocs, tabsFilter.currentTab, SortOption.Date, SortOrder.Descending);
    var filterDocuments = useCallback(function (docs) {
        if (!filterFunctions.length) {
            return docs.filter(function (doc) { return showHidden === !!doc.isHidden; });
        }
        return docs.filter(function (doc) {
            return showHidden === !!doc.isHidden &&
                filterFunctions.every(function (filterFunction) {
                    return filterFunction(doc);
                });
        });
    }, [filterFunctions, showHidden]);
    var filteredDocs = useMemo(function () { return filterDocuments(sortedDocs).slice(0, maxItemCount); }, [filterDocuments, maxItemCount, sortedDocs]);
    var isTagEmptyState = useMemo(function () {
        var _a;
        var customPivot = getCustomPivotFromTabId(tabsFilter.currentTab, tags === null || tags === void 0 ? void 0 : tags.tagIdToItemsDocumentIdsMap);
        return (tags &&
            customPivot &&
            ((_a = tags.tagIdToItemsDocumentIdsMap.get(customPivot.customFilterKey)) === null || _a === void 0 ? void 0 : _a[1].size) === 0);
    }, [tabsFilter.currentTab, tags]);
    var emptyState = useEmptyState({
        emptyStateResources: emptyStateResources,
        filterText: tabsFilter.activeFilters.length &&
            tabsFilter.activeFilters[0].customFilterType
            ? getCustomPivotTitle(tabsFilter.activeFilters[0]) || ''
            : '',
        currentTab: tabsFilter.currentTab,
        darkMode: darkMode,
        isMsa: identity === null || identity === void 0 ? void 0 : identity.isMsa,
        isCustomPivot: !!(tabsFilter.activeFilters.length &&
            tabsFilter.activeFilters[0].customFilterType),
        isEmptyTag: isTagEmptyState,
        isDesktopApp: isDesktopApp,
        isError: isError,
    });
    // use a separate ref for allDocs to avoid passing this as a dependency for virtualListProps, since
    // we only need allDocs when onMeetingArtifactClick gets called
    var allDocsRef = useRef();
    allDocsRef.current = allDocs;
    var onAddPendingPivot = useCallback(function () {
        var filter = {
            customFilterType: CustomFilterType.Pending,
            customFilterKey: '',
        };
        var newCustomPivots = customPivots ? __spreadArray([], __read(customPivots), false) : [];
        if (!newCustomPivots.find(function (pivot) { return pivot.customFilterType === CustomFilterType.Pending; })) {
            newCustomPivots.push(filter);
            setCustomPivots(newCustomPivots);
        }
        if (customPivotsEnabled && !showCustomPivotMenu) {
            setShowCustomPivotMenu(true);
            setActiveCustomPivotTabId(getCustomPivotTabId(filter));
        }
    }, [
        customPivots,
        customPivotsEnabled,
        setCustomPivots,
        showCustomPivotMenu,
    ]);
    var onRemovePendingPivot = useCallback(function () {
        setShowCustomPivotMenu(false);
        var filterTypeString = CustomFilterType.Pending.toString();
        var filterKey = '';
        if (customPivots &&
            customPivots.find(function (pivot) {
                return pivot.customFilterType.toString() === filterTypeString &&
                    pivot.customFilterKey === filterKey;
            })) {
            setCustomPivots(customPivots.filter(function (pivot) {
                return pivot.customFilterKey !== filterKey ||
                    pivot.customFilterType.toString() !== filterTypeString;
            }));
        }
    }, [customPivots, setCustomPivots]);
    var wrapperOnAddCustomPivot = useCallback(function (filter) {
        setShowCustomPivotMenu(false);
        setActiveCustomPivotTabId(getCustomPivotTabId(filter));
        var newCustomPivots = customPivots ? __spreadArray([], __read(customPivots), false) : [];
        if (!newCustomPivots.find(function (pivot) {
            return pivot.customFilterType === filter.customFilterType &&
                pivot.customFilterKey === filter.customFilterKey;
        })) {
            if (onAddCustomPivot) {
                onAddCustomPivot(filter.customFilterType, filter.customFilterKey);
            }
            newCustomPivots.push(filter);
        }
        setCustomPivots(newCustomPivots.filter(function (pivot) {
            return pivot.customFilterType !== CustomFilterType.Pending &&
                pivot.customFilterKey !== '';
        }));
    }, [customPivots, onAddCustomPivot, setCustomPivots]);
    var clearCommandFilters = useCallback(function (filterKey, filterType) {
        var _a, _b, _c;
        switch (filterType) {
            case CustomFilterType.SharedBy:
                if (filterKey
                    .toLowerCase()
                    .includes((_a = commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.sharedByFilterText) === null || _a === void 0 ? void 0 : _a.toLowerCase())) {
                    (commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.clearCommandFilterNameText) &&
                        (commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.clearCommandFilterNameText());
                }
                break;
            case CustomFilterType.Tagv2:
            case CustomFilterType.Tag:
                if (((_b = commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.tagText) === null || _b === void 0 ? void 0 : _b.toLowerCase()) ===
                    filterKey.split(' ')[1].toLowerCase()) {
                    (commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.clearCommandFilterTagText) &&
                        (commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.clearCommandFilterTagText());
                }
                break;
            case CustomFilterType.FileType:
                if (((_c = commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.fileTypeText) === null || _c === void 0 ? void 0 : _c.toLowerCase()) ===
                    filterKey.toLowerCase()) {
                    (commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.clearCommandFilterFileText) &&
                        (commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.clearCommandFilterFileText());
                }
                break;
        }
    }, [commandFilterProps]);
    var wrappedOnRemoveCustomPivot = useCallback(function (pivot) {
        // Parse customFilterType and customFilterKey from pivot.id, which format is customPivot.customFilterType + '-' + customPivot.customFilterKey, defined in useTabsFilter.
        var pivotId = pivot.id;
        var separatorIndex = pivotId.indexOf(CustomPivotTabIdSeparator);
        if (separatorIndex < 0) {
            return;
        }
        var filterTypeString = pivotId.substring(0, separatorIndex);
        var filterKey = pivotId.substring(separatorIndex + 1);
        var filterType = CustomFilterType[filterTypeString];
        if (commandingEnabled) {
            clearCommandFilters(pivot.title, filterType);
        }
        if (onRemoveCustomPivot) {
            onRemoveCustomPivot(filterType, filterKey);
        }
        if (customPivots &&
            customPivots.find(function (pivot) {
                return pivot.customFilterType.toString() ===
                    filterTypeString &&
                    pivot.customFilterKey === filterKey;
            })) {
            setCustomPivots(customPivots.filter(function (pivot) {
                return pivot.customFilterKey !== filterKey ||
                    pivot.customFilterType.toString() !==
                        filterTypeString;
            }));
        }
    }, [
        clearCommandFilters,
        commandingEnabled,
        customPivots,
        onRemoveCustomPivot,
        setCustomPivots,
    ]);
    var onRemovePivot = useCallback(function (pivot) {
        if (!pivot || !pivot.id) {
            return;
        }
        if (pivot.id === PendingCustomPivotId) {
            onRemovePendingPivot();
        }
        else if (deleteCustomPivot) {
            deleteCustomPivot(function () { return wrappedOnRemoveCustomPivot(pivot); });
        }
    }, [deleteCustomPivot, onRemovePendingPivot, wrappedOnRemoveCustomPivot]);
    useEffect(function () {
        if (showCustomPivotMenu && onShowCustomPivotsMenu) {
            onShowCustomPivotsMenu();
        }
    }, [showCustomPivotMenu, onShowCustomPivotsMenu]);
    var quickAccessActionSection = (React.createElement("div", { className: styles['quick-access-action-section'] }, navigateToMyContent && (React.createElement(ActionButton, { className: classNames(styles['my-content-button']), iconProps: rightArrowIconProps, styles: myContentButtonStyle, text: locResources.seeAllMyContentLinkText, onClick: function () { return navigateToMyContent(tabsFilter.currentTab); }, "data-clicklog": "custom" }))));
    var emptyStateSection;
    if (filteredDocs.length === 0 && emptyState) {
        emptyStateSection = (React.createElement(EmptyStateControl, { emptyState: emptyState, cdnDomain: cdnDomain }));
        if (isVisualRefresh) {
            emptyStateSection = (React.createElement("div", { className: styles['quick-acess-empty-state-wrapper'] }, emptyStateSection));
        }
    }
    // Refer comments above type declaration for more details.
    window.getEdgeworthSuggestions = {
        allDocs: allDocs || [],
        sortedDocs: sortedDocs || [],
        filteredDocs: filteredDocs || [],
    };
    //TODO Move this logic to handler
    //Update the check for email to be more robust
    var previousCommandFilterProps = usePrevious(commandFilterProps);
    useEffect(function () {
        var e_1, _a;
        if (commandingEnabled) {
            //SharedBy filter
            if ((previousCommandFilterProps === null || previousCommandFilterProps === void 0 ? void 0 : previousCommandFilterProps.sharedByFilterText) !==
                (commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.sharedByFilterText)) {
                if ((commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.sharedByFilterText) &&
                    commandFilterProps.sharedByFilterText.length > 0) {
                    //gets the upn from name, to show the picture on pivot
                    var customFilterKey = commandFilterProps.sharedByFilterText;
                    if (!commandFilterProps.sharedByFilterText.includes('@') &&
                        getOrCreateUpnNameMap) {
                        var map = getOrCreateUpnNameMap();
                        try {
                            for (var _b = __values(map.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                                if (value.toLowerCase() ===
                                    commandFilterProps.sharedByFilterText.toLowerCase() ||
                                    value
                                        .toLowerCase()
                                        .indexOf(commandFilterProps.sharedByFilterText.toLowerCase()) >= 0) {
                                    customFilterKey = key;
                                    break;
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                    wrapperOnAddCustomPivot({
                        customFilterType: CustomFilterType.SharedBy,
                        customFilterTitle: commandFilterProps.sharedByFilterText,
                        customFilterKey: customFilterKey,
                    });
                }
            }
            //Tag filter
            if ((previousCommandFilterProps === null || previousCommandFilterProps === void 0 ? void 0 : previousCommandFilterProps.tagText) !==
                (commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.tagText) &&
                (commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.tagText)) {
                var customFilterTitle = commandFilterProps.tagText;
                var customFilterKey = (tags && tags.getTagIdByTagValue(customFilterTitle)) || '';
                if (customFilterKey) {
                    // Handle error response when tag is not found in filterEntity.ts
                    wrapperOnAddCustomPivot({
                        customFilterType: CustomFilterType.Tagv2,
                        customFilterTitle: customFilterTitle,
                        customFilterKey: customFilterKey,
                    });
                }
            }
            //FileType filter
            if ((previousCommandFilterProps === null || previousCommandFilterProps === void 0 ? void 0 : previousCommandFilterProps.fileTypeText) !==
                (commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.fileTypeText)) {
                var customFilterTitle = commandFilterProps && commandFilterProps.fileTypeText;
                var customFilterKey = customFilterTitle && FileFilterKey[customFilterTitle];
                if (customFilterKey) {
                    wrapperOnAddCustomPivot({
                        customFilterType: CustomFilterType.FileType,
                        customFilterTitle: customFilterTitle,
                        customFilterKey: customFilterKey,
                    });
                }
            }
        }
    }, [
        commandFilterProps,
        commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.fileTypeText,
        commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.sharedByFilterText,
        commandFilterProps === null || commandFilterProps === void 0 ? void 0 : commandFilterProps.tagText,
        commandingEnabled,
        getOrCreateUpnNameMap,
        navigateToMyContent,
        previousCommandFilterProps === null || previousCommandFilterProps === void 0 ? void 0 : previousCommandFilterProps.fileTypeText,
        previousCommandFilterProps === null || previousCommandFilterProps === void 0 ? void 0 : previousCommandFilterProps.sharedByFilterText,
        previousCommandFilterProps === null || previousCommandFilterProps === void 0 ? void 0 : previousCommandFilterProps.tagText,
        tags,
        wrappedOnSelectTab,
        wrapperOnAddCustomPivot,
    ]);
    return (React.createElement(LayoutSwitchControl, { defaultLayout: currentLayout || LayoutOption.List },
        React.createElement("div", { id: "quick-access", className: isVisualRefresh
                ? styles['quick-access__wrapper-refresh']
                : styles['quick-access__wrapper'] },
            React.createElement("h3", { className: styles['quick-access-title'] }, locResources.quickAccessTitle),
            React.createElement("div", { className: styles['tab-list'] },
                React.createElement("div", { className: styles['tab-list__header'] },
                    React.createElement(PivotsControl, __assign({}, tabsFilter.pivotProps, { showPills: true, activeTabId: tabsFilter.currentTab, pivotsOverflow: (identity === null || identity === void 0 ? void 0 : identity.isMsa)
                            ? PivotsOverflow.None
                            : PivotsOverflow.Dropdown, dropdownButtonText: (identity === null || identity === void 0 ? void 0 : identity.isMsa)
                            ? ''
                            : locResources.moreButtonWithNumberTitle, onAddPendingPivot: customPivotsEnabled &&
                            (!customPivotsProps ||
                                customPivotsProps.length < 10) // Limit custom pivots to 10
                            ? onAddPendingPivot
                            : undefined, onRemovePivot: customPivotsEnabled ? onRemovePivot : undefined, pendingCustomPivotId: customPivotsEnabled
                            ? PendingCustomPivotId
                            : undefined, addCustomPivotButtonText: customPivotsEnabled
                            ? locResources.customPivotMenuTitle
                            : undefined, removeNewCustomPivotButtonText: customPivotsEnabled
                            ? locResources.removeNewCustomPivotButtonText
                            : undefined, removeNamedCustomPivotButtonText: customPivotsEnabled
                            ? locResources.removeNamedCustomPivotButtonText
                            : undefined })),
                    uploadButton ? uploadButton : null,
                    gridViewEnabled && (React.createElement(LayoutOptions, { locResources: layoutResources, onChangeLayout: onChangeLayout })))),
            React.createElement(React.Fragment, null, showCustomPivotMenu && getOrCreateUpnNameMap ? (React.createElement(CustomPivotsMenuControl, { locResources: locResources, getOrCreateUpnNameMap: getOrCreateUpnNameMap, fetchPictureData: fetchPictureData, fluidSupportEnabled: fluidSupportEnabled, onSelectCustomFilter: customPivotsEnabled
                    ? wrapperOnAddCustomPivot
                    : undefined, tags: tags })) : (React.createElement("div", { id: "edgeworthbase", role: "table", "aria-label": locResources.quickAccessTitle, className: isVisualRefresh &&
                    currentLayout !== LayoutOption.Grid
                    ? styles['base-edgeworth__wrapper-refresh']
                    : styles['base-edgeworth__wrapper'] },
                emptyStateSection,
                React.createElement(LayoutContent, null,
                    React.createElement(QuickAccessListViewControl, { currentLayout: LayoutOption.List, filteredDocs: filteredDocs, current: allDocsRef.current, callbacks: wrappedCallbacks, dateResources: dateResources, edgeworthItemResources: edgeworthItemResources, edgeworthTaggingResources: edgeworthTaggingResources, isVisualRefresh: isVisualRefresh, preferredCulture: preferredCulture, currentTab: tabsFilter.currentTab, PeopleCard: PeopleCard, tags: tags, msaUserHint: msaUserHint }),
                    React.createElement(QuickAccessGridViewControl, { currentLayout: LayoutOption.Grid, filteredDocs: filteredDocs, current: allDocsRef.current, callbacks: wrappedCallbacks, dateResources: dateResources, edgeworthItemResources: edgeworthItemResources, edgeworthTaggingResources: edgeworthTaggingResources, preferredCulture: preferredCulture, workloadColorMap: workloadColorMap, tags: tags, currentTab: tabsFilter.currentTab, isMsa: identity === null || identity === void 0 ? void 0 : identity.isMsa })),
                !isVisualRefresh && quickAccessActionSection))),
            isVisualRefresh && quickAccessActionSection)));
};
//# sourceMappingURL=QuickAccessControl.js.map